import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animallistv2',
  templateUrl: './animallistv2.component.html',
  styleUrls: ['./animallistv2.component.scss']
})
export class Animallistv2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
